export default "__VITE_ASSET__81bca8c7__"